module.exports = __webpack_public_path__ + "static/media/practice_light.24261232.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/practice_light.png
// module id = 3543
// module chunks = 3